import { Link } from "react-router-dom";
import { Fragment } from "react";

import SearchBar from "./SearchBar";

function CoverText({ page, text, short }) {

    return (
        <Fragment>
            <div className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center">
                <div className="titles d-block text-center">
                    <div className="top-title">{(text && text[page]?.cover?.upper) || ""}</div>
                    <div className="middle-title">{(text && text[page]?.cover?.middle) || ""}</div>
                    <div className="bottom-title">{titleCase((((text && text[page]?.cover?.lower) || "") + "").toLowerCase())}</div>

                    <br />
                    <SearchBar />
                </div>
            </div>
            <div className="footer-scroll m-auto"><img src="./Images/scroll-3.gif" alt="" className="img img-fluid d-block" style={short ? { marginTop: "30px" } : {}} /></div>
        </Fragment>
    );
}

function titleCase(str) {
    if (!str) return str;
    return str.replace(/(^)\w/g, txt => (txt.substr(0, txt.length - 1) + txt.substr(txt.length - 1).toUpperCase()))
}

export default CoverText;